import { AxiosAdapter } from '../commons/adapters';
import { IServicesIaCustomerSuscriptionsBackendRequestDto } from '../pages/manager/servicios-ia/comercial/suscripciones/interfaces';
import { QueryPagination } from 'commons/interfaces';
import { buildQuery } from 'commons/utils/helpers';

const endPoint = '/v1/services-ia-customer-suscriptions';
const Http = new AxiosAdapter();

export const getServicesIaSuscriptionsFormService = async () => {
  try {
    return await Http.get<any>(`${endPoint}/form`);
  } catch (error: any) {
    if (error && !error.ok) return error;
    console.error('getServicesIaSuscriptionsFormService error', error);
  }
};

export const getAllServicesIaCustomerSuscriptionsService = async (query?: QueryPagination) => {
  try {
    return await Http.get<any>(`${endPoint}?${buildQuery(query)}`);
  } catch (error: any) {
    if (error && !error.ok) return error;
    console.error('getAllServicesIaCustomerSuscriptionsService error', error);
  }
};

export const getServicesIaCustomerSuscriptionByIdService = async (id: string) => {
  try {
    return await Http.get<any>(`${endPoint}/${id}`);
  } catch (error: any) {
    if (error && !error.ok) return error;
    console.error('getServicesIaCustomerSuscriptionByIdService error', error);
  }
};

export const saveServicesIaCustomerSuscriptionService = async (
  data: IServicesIaCustomerSuscriptionsBackendRequestDto
) => {
  try {
    return await Http.post<any>(`${endPoint}`, data);
  } catch (error: any) {
    if (error && !error.ok) return error;
    console.error('saveServicesIaCustomerSuscriptionService error', error);
  }
};

export const editServicesIaCustomerSuscriptionService = async (
  id: string,
  data: IServicesIaCustomerSuscriptionsBackendRequestDto
) => {
  try {
    return await Http.put<any>(`${endPoint}/${id}`, data);
  } catch (error: any) {
    if (error && !error.ok) return error;
    console.error('editServicesIaCustomerSuscriptionService error', error);
  }
};

export const deleteServicesIaCustomerSuscriptionService = async (
  id: string,
  query?: QueryPagination
) => {
  try {
    return await Http.deleteTable<any>(`${endPoint}/${id}?${buildQuery(query)}`);
  } catch (error: any) {
    if (error && !error.ok) return error;
    console.error('deleteServicesIaCustomerSuscriptionService error', error);
  }
};

export const restoreServicesIaCustomerSuscriptionService = async (
  id: string,
  query?: QueryPagination
) => {
  try {
    return await Http.patchTable<any>(`${endPoint}/${id}/restore?${buildQuery(query)}`);
  } catch (error: any) {
    if (error && !error.ok) return error;
    console.error('restoreServicesIaCustomerSuscriptionService error', error);
  }
};
